module.exports = __webpack_public_path__ + "static/media/carret_down.9d5af614.svg";